import {client as clientAxios} from "@src/library/axios.library";
import {AxiosResponse} from "axios";
import {ProcessFlowType} from "@process/types/processFlow.types";

export const getProcessFlowList = async (processId: string): Promise<ProcessFlowType[]> => {
    const {data} = await clientAxios.get<never, AxiosResponse<ProcessFlowType[]>>(`/api/v1/process/${processId}/flow`);
    return data;
}